import React from "react";

function AccountBasedMarketingIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M43.21 16.194l-2.7 2.63a.574.574 0 01-.401.16h-.07l-.252-.034-1.343-.149-2.676 2.814-2.389 2.504-.792.826-1.574 1.666-.804.838-1.596 1.677-1.94 2.032a.59.59 0 01-.426.173.569.569 0 01-.413-.965l1.94-2.033 1.597-1.676.804-.839 1.585-1.665.792-.838 2.389-2.493 2.607-2.733-.138-1.435-.034-.39a.603.603 0 01.172-.472l2.699-2.63a.569.569 0 01.964.356l.138 1.516 1.516.173a.569.569 0 01.482.39.603.603 0 01-.137.597zm-9.084 8.809a9.756 9.756 0 11-7.879-4.008 9.613 9.613 0 015.386 1.63l2.4-2.526a13.089 13.089 0 00-7.786-2.55 13.227 13.227 0 1010.279 4.927l-2.4 2.527zm-3.308-1.54a8.513 8.513 0 00-4.57-1.32 8.613 8.613 0 108.613 8.613 8.514 8.514 0 00-1.54-4.903l-1.63 1.71c.578.965.88 2.07.873 3.193a6.316 6.316 0 11-6.317-6.316 6.165 6.165 0 012.94.735l1.631-1.711zm-4.57 4.422c.114 0 .229.012.344.023l1.78-1.86a5.167 5.167 0 103.043 4.709 4.993 4.993 0 00-.563-2.332l-1.768 1.872c.023.152.035.306.034.46a2.87 2.87 0 11-2.87-2.872z"
            ></path>
        </svg>
    );
}

export default AccountBasedMarketingIcon;
